import { FormTemplate } from 'data/template/template.types';

export const afFilterTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Filter Group',
  key: 'afFilter',
  main: {
    metadata: {
      layout: {
        rows: [
          ['afName', 'fgName', '$empty'],
        ],
      },
    },
    fields: {
      fgName: {
        label: 'Filter Group Name',
        type: 'select',
        initial: '',
        options: [],
      },
      afName: {
        label: 'Access Function',
        type: 'select',
        initial: '',
        options: [],
      },
    },
  },
};
